import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import DocumentForm from './DocumentForm'

import { replaceDocument } from '../services'

export default function EditDocumentModal({ visible, onClose, reload, document }) {
	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<DocumentForm 
						apiService={data => replaceDocument(document.id, data)}
						defaultTitle={document.title}
						defaultKeywords={document.keywords}
						onSuccess={() => {
							message.success('Documento actualizado correctamente')
							reload()
							onClose()
						}}
						isUpdate
					/>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}